import { cue } from './cues.js';

/**
 * Every button of the interface ticks when pressed, and a window's cross
 * sounds its closing: one listener for the whole DOM rather than a line in
 * every panel, so a panel added later sounds like the others for free.
 */
export function installUiSounds(): void {
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('button');
      if (button === null || button.disabled) return;
      cue(button.classList.contains('panel-close') ? 'sfx.close' : 'sfx.click');
    },
    { capture: true },
  );
}
